import { ref, markRaw } from 'vue';
import ModalsContainer from './ModalsContainer.vue';

const Plugin = {
    install(app, cfg = {}) {
        if (this.installed) return;

        this.installed = true;
        this.modals = ref([]);
        app.component('ModalsContainer', ModalsContainer);
        app.provide('$modals', this.modals);

        const addModal = (modalType, props) => {
            let id = new Date().getTime();

            this.modals.value.push({
                id,
                type: modalType,
                modal: props,
            });

            return id;
        };
        const removeModal = (id) => {
            const modals = this.modals.value;
            const index = modals.findIndex((item) => item.id === id);

            if (index !== -1) {
                modals.splice(index, 1);
            }

            return this.modals;
        };

        const showModal = (modalType, component, componentProps, modalProps, events = {}) => {
            if (component instanceof Promise) {
                component.then((resolve) => {
                    addModal(modalType, {
                        component: markRaw(resolve.default),
                        componentAttrs: componentProps,
                        modalAttrs: { ...cfg.modalProps, ...modalProps },
                        events,
                    });
                });
            } else
                addModal(modalType, {
                    component: markRaw(component),
                    componentAttrs: componentProps,
                    modalAttrs: { ...cfg.modalProps, ...modalProps },
                    events,
                });
        };

        app.config.globalProperties.$modal = {
            show(component, componentProps, modalProps, events = {}) {
                showModal('dialog', component, componentProps, modalProps, events);
            },
            showBottom(component, componentProps, modalProps, events = {}) {
                showModal('bottom', component, componentProps, modalProps, events);
            },
            showDynamic(component, componentProps, modalProps, events = {}) {
                showModal('dynamic', component, componentProps, modalProps, events);
            },
            close(id) {
                return removeModal(id);
            },
        };
    },
};

export default Plugin;
